import { api } from "api/base-config";

/** ---- API CALLS ---- */
export const sendError = async (
  message: string,
  stacktrace?: string
): Promise<void> => {
  return api
    .post(`/resources/secured/rs/logger`, [
      createClientLogDTO(message, stacktrace)
    ])
    .then();
};

/** ---- API DTO ---- */
const createClientLogDTO = (message: string, stacktrace?: string) => {
  return {
    "@type": "LogRecord",
    level: "ERROR",
    message: message,
    stacktrace: stacktrace,
    sourceClassName: "",
    sourceMethodName: "",
    loggerName: "CC Visit",
    timestamp: new Date().getTime()
  };
};
